import {transactionTypes} from '@bdswiss/common-enums'
import {map, filter, includes} from 'lodash'

export function isTransferTransactionType(type) {
  const transferTypes = map(filter(transactionTypes, (type) => type.isTransfer), 'value')

  return includes(transferTypes, type)
}
